import { Trans } from '@lingui/macro'
import {
  Paper,
  Step,
  StepButton,
  StepContent,
  Stepper,
  Typography,
} from '@material-ui/core'
import { css } from 'emotion'
import React, { useMemo, useState } from 'react'
import { IAccount } from 'shopify-payment-core'

import { BillingStep } from '../steps/BillingStep'
import { ConfigureGatewayStep } from '../steps/ConfigureGatewayStep'
import { GoPayStep } from '../steps/GoPayStep'
import { InstallGatewayStep } from '../steps/InstallGatewayStep'

interface IProps {
  account: IAccount
  initialStep?: number
}

const getSteps = () => [
  GoPayStep,
  InstallGatewayStep,
  ConfigureGatewayStep,
  BillingStep,
]

export const AccountWizard: React.FC<IProps> = ({
  account,
  initialStep = 0,
}) => {
  const steps = useMemo(getSteps, [])
  const [activeStep, setActiveStep] = useState(initialStep)
  const onNext = () => setActiveStep(step => step + 1)
  return (
    <Paper
      className={css`
        margin: 1rem;
        padding: 1rem;
      `}
    >
      <Typography variant="h5" display="inline">
        <Trans>Průvodce instalací a nastavením</Trans>
      </Typography>{' '}
      <Typography variant="h6" gutterBottom display="inline">
        {`${account.shopName}.myshopify.com`}
      </Typography>
      <Stepper orientation="vertical" nonLinear activeStep={activeStep}>
        {steps.map((step, index) => (
          <Step key={index}>
            <StepButton
              onClick={() => setActiveStep(index)}
              completed={false}
              disabled={false}
            >
              {step.getStepLabel()}
            </StepButton>
            <StepContent>{step({ account, onNext })}</StepContent>
          </Step>
        ))}
      </Stepper>
    </Paper>
  )
}
